import Service from './Service';

const resource = '/api/identidades-genero';

export default {
    index() {
        return Service.get(`${resource}`);
    }
}
